import { useTranslation } from "react-i18next";
import { useRemoveWishlistItemMutation } from "../api/wishlistApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for removing an item from the wishlist.
 */
export const useRemoveFromWishlist = () => {
  const { t } = useTranslation();
  const [removeWishlistItem, removeResult] = useRemoveWishlistItemMutation();

  const { trigger: handleRemoveFromWishlist, isLoading: isRemoving } =
    useMutationWithFeedback({
      mutation: [removeWishlistItem, removeResult],
      loadingMessage: t("feedback.wishlist.loading", "Updating wishlist..."),
      successMessage: t(
        "feedback.wishlist.removedSuccess",
        "Removed from wishlist"
      ),
      errorMessages: {
        default: t(
          "feedback.wishlist.toggleError",
          "Failed to update wishlist. Please try again."
        ),
      },
      successToastType: "info", // Specify the 'info' toast style for success
    });

  return {
    handleRemoveFromWishlist,
    isRemoving,
  };
};
